<template>
    <div>
        <nav class="breadcrumb bg-white push">
            <a class="breadcrumb-item" href="javascript:void(0)">Dashboard</a>
            <span class="breadcrumb-item active">Overview</span>
        </nav>

        <div class="row gutters-tiny">
            <div class="col-md-3 col-xl-3">
                <a class="block block-link-shadow" href="javascript:void(0)">
                    <div class="block-content block-content-full">
                        <div class="py-20 text-center">
                            <div class="mb-20">
                                <i class="si si-users fa-4x text-info"></i>
                            </div>
                            <div class="font-size-h3 font-w600">
                                {{ info.users }}
                            </div>
                            <div
                                class="font-size-sm font-w600 text-uppercase text-muted"
                            >
                                Users
                            </div>
                        </div>
                    </div>
                </a>
            </div>
            <div class="col-md-3">
                <!-- Modern on Background Color -->
                <div class="block">
                    <div class="block-content block-content-full">
                        <div class="py-20 text-center">
                            <div class="mb-20">
                                <i
                                    class="si si-credit-card fa-4x text-success"
                                ></i>
                            </div>
                            <div class="font-size-h3 font-w600">
                                {{ info.cards }}
                            </div>
                            <div
                                class="font-size-sm font-w600 text-uppercase text-muted"
                            >
                                Card Requests
                            </div>
                        </div>
                    </div>
                </div>
                <!-- END Modern on Background Color -->
            </div>
            <div class="col-md-3">
                <!-- Modern on Background Color -->
                <div class="block">
                    <div class="block-content block-content-full">
                        <div class="py-20 text-center">
                            <div class="mb-20">
                                <i class="fa fa-money fa-4x text-danger"></i>
                            </div>
                            <div class="font-size-h3 font-w600">
                                {{ info.loans }}
                            </div>
                            <div
                                class="font-size-sm font-w600 text-uppercase text-muted"
                            >
                                Loans
                            </div>
                        </div>
                    </div>
                </div>
                <!-- END Modern on Background Color -->
            </div>
            <div class="col-md-3 col-xl-3">
                <a class="block block-link-shadow" href="javascript:void(0)">
                    <div class="block-content block-content-full">
                        <div class="py-20 text-center">
                            <div class="mb-20">
                                <i class="si si-wallet fa-4x text-info"></i>
                            </div>
                            <div class="font-size-h3 font-w600">
                                {{ info.transactions }}
                            </div>
                            <div
                                class="font-size-sm font-w600 text-uppercase text-muted"
                            >
                                Transactions
                            </div>
                        </div>
                    </div>
                </a>
            </div>

            <!-- END Row #2 -->
        </div>

        <!-- live chart starts -->

        <!-- live chart ends -->
    </div>
</template>

<script>
import { RepositoryFactory } from "../../repository/RepositoryFactory";

const UsersRepository = RepositoryFactory.get("users");
export default {
    data() {
        return {
            info: []
        };
    },
    methods: {
        async getOverview() {
           var res =  await UsersRepository.adminGetDashboard();
           this.info = res.data;
        }
    },
    created(){
        this.getOverview();
    }
};
</script>
